import { Flex, Modal, Title, createStyles } from "@mantine/core";
import epicLogo from "../assets/img/epicLogo.svg"
import googleFitLogo from "../assets/img/googleFitLogo.svg";
import dexcomLogo from "../assets/img/dexcomLogo.svg";
import cernerLogo from "../assets/img/cernerLogo.svg";
import { platformLogo } from "../utils";


const useStyles = createStyles((theme) => ({
    connectingText: {
        fontSize: "22px",
        fontWeight: "bold"
    },
    icon: {
        height: "35px",
        marginLeft: "5px",
        marginBottom: "4px"
    },
    epicLogo: {
        height: "50px",
        width: "80px",
    }
  }));

export function RedirectingModal(props: any) {
    const { classes } = useStyles();

    return (
            <Modal
                opened={props.isOpen}
                onClose={() => {props.onClose()}}
                size={"md"}
                withCloseButton={false}
                centered
            >
                 <Flex
                    mih={200}
                    justify="center"
                    align="center"
                    direction={"column"}
                    gap={"15px"}
                    >
                    <img src={platformLogo[props.vendor?.replace(/\s/g, '')?.toLowerCase()]} alt="" className={classes.epicLogo}/>
                    <Title className={classes.connectingText}>
                        {props.text}
                    </Title>
                    <Title size={"xl"}>{`Please wait, we are ${props.text === "Creating Appointment..." ? "Creating Appointment...": `redirecting you to ${props.vendor}`}`} </Title>
                </Flex>
            </Modal>
    )
}